var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("customer-select-input", {
    attrs: {
      name: "account-nav",
      required: true,
      selected: _vm.selected,
      options: _vm.options,
      showIcon: false
    },
    on: { input: _vm.handleRedirect }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }